import { useState, useRef, useEffect, useCallback } from 'react';

export function useToasts() {
  const [toasts, setToasts] = useState([]);
  const toastTimers = useRef({});

  // Cleanup de timers ao desmontar
  useEffect(() => {
    const timers = toastTimers.current;
    return () => {
      Object.values(timers).forEach(clearTimeout);
    };
  }, []);

  const addToast = useCallback((title, message, type = 'info') => {
    const toastId = Date.now();
    const newToast = { id: toastId, title, message, type };
    setToasts(prev => [...prev, newToast]);

    toastTimers.current[toastId] = setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== toastId));
      delete toastTimers.current[toastId];
    }, 5000);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
    if (toastTimers.current[id]) {
      clearTimeout(toastTimers.current[id]);
      delete toastTimers.current[id];
    }
  }, []);

  return { toasts, addToast, removeToast, setToasts };
}
